import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ScrollToModule } from 'ng2-scroll-to';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
// import { Http, ConnectionBackend } from '@angular/http';
import { HttpModule } from '@angular/http';
import { NgxMasonryModule } from 'ngx-masonry';

import { ScrollEventModule } from 'ngx-scroll-event';
import { NgxCarouselModule } from 'ngx-carousel';
import { ClickOutsideModule } from 'ng-click-outside';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Main layout
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';

// Home
import { HomeComponent } from './pages/home/home.component';
import { MainBannerComponent } from './pages/home/main-banner/main-banner.component';
import { TestimonialsComponent } from './pages/home/testimonials/testimonials.component';
import { EventsComponent } from './pages/home/events/events.component';
import { MessageFormComponent } from './pages/home/message-form/message-form.component';

// Portfolio
import { PortfolioPreviewComponent } from './pages/portfolio/preview/portfolio-preview.component';
import { PortfolioPageComponent } from './pages/portfolio/portfolio-page/portfolio-page.component';
import { PortfolioListComponent } from './pages/portfolio/portfolio-list/portfolio-list.component';

// Common components
import { CardComponent } from './_common/card/card.component';

// Services
import { ModalService } from './_common/modal/modal-service';
import { ModalComponent } from './_common/modal/modal.component';
import { PortfolioRoutingComponent } from './pages/portfolio/portfolio-routing/portfolio-routing.component';
import { DropdownComponent } from './_common/dropdown/dropdown.component';

// Pipes
import { OrderModule } from 'ngx-order-pipe';
import { PortfolioProjectPreviewComponent } from './pages/portfolio/portfolio-project-preview/portfolio-project-preview.component';

// Projects
import { MonopolistComponent } from './pages/portfolio/projects/monopolist/monopolist.component';
import { TeamsComponent } from './pages/portfolio/projects/teams/teams.component';
import { ArticleuiComponent } from './pages/portfolio/projects/articleui/articleui.component';
import { FiveHundredPxComponent } from './pages/portfolio/projects/500px/500px.component';
import { BasicjaneComponent } from './pages/portfolio/projects/basicjane/basicjane.component';
import { TomfrenchComponent } from './pages/portfolio/projects/tomfrench/tomfrench.component';
import { NovoComponent } from './pages/portfolio/projects/novo/novo.component';
import { SpectreComponent } from './pages/portfolio/projects/spectre/spectre.component';
import { QuflipComponent } from './pages/portfolio/projects/quflip/quflip.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    MainBannerComponent,
    HomeComponent,
    PortfolioPreviewComponent,
    EventsComponent,
    MessageFormComponent,
    TestimonialsComponent,
    FooterComponent,
    CardComponent,
    PortfolioPageComponent,
    PortfolioListComponent,
    ModalComponent,
    PortfolioRoutingComponent,
    DropdownComponent,
    PortfolioProjectPreviewComponent,

    // Projects
    FiveHundredPxComponent,
    QuflipComponent,
    SpectreComponent,
    BasicjaneComponent,
    NovoComponent,
    TomfrenchComponent,
    MonopolistComponent,
    TeamsComponent,
    ArticleuiComponent,
  ],
  entryComponents: [
    // Projects
    FiveHundredPxComponent,
    QuflipComponent,
    SpectreComponent,
    BasicjaneComponent,
    NovoComponent,
    TomfrenchComponent,
    MonopolistComponent,
    TeamsComponent,
    ArticleuiComponent,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    AppRoutingModule,
    FormsModule,
    ScrollToModule.forRoot(),
    ScrollEventModule,
    NgxCarouselModule,
    ClickOutsideModule,
    BrowserAnimationsModule,
    NgxMasonryModule,
    OrderModule,
  ],
  providers: [ModalService],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts